export default __webpack_public_path__ + "static/media/small-logo-AiVoice-new.546b6a65.svg";